export enum ProductType {
  SuperTrakGen3 = 'SuperTrakGen3',
  SuperTrakMicro = 'SuperTrakMicro',
}
